import type { SVGProps } from 'react';

export default function Fork2(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.125 10.375L7.41421 11.6642C7.78929 12.0393 8.30285 12.2725 8.82335 12.1703L9.96403 11.7699L17.0701 18.876C17.5688 19.3747 18.3773 19.3747 18.876 18.876C19.3747 18.3773 19.3747 17.5688 18.876 17.0701L11.7699 9.96403L12.1703 8.82335C12.2725 8.30285 12.0393 7.78929 11.6642 7.41421L10.375 6.125M6.125 10.375L4.75 9M6.125 10.375C8.20312 8.29688 7.61683 7.61683 6.83579 6.83579M6.83579 6.83579L6.75 6.75M6.83579 6.83579C7.61683 7.61683 8.88317 7.61683 9.66421 6.83579L10.375 6.125M10.375 6.125L9 4.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
